module.exports = {"150721100":"那吉镇","150721101":"六合镇","150721102":"亚东镇","150721103":"霍尔奇镇","150721104":"向阳峪镇","150721105":"三岔河镇","150721106":"复兴镇","150721107":"兴安镇","150721200":"得力其尔鄂温克民族乡","150721201":"查巴奇鄂温克民族乡","150721202":"音河达斡尔鄂温克民族乡","150721203":"新发朝鲜民族乡","150721400":"那吉屯农场","150721401":"格尼河农场","150721402":"阿荣旗林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150721.json
// module id = 447
// module chunks = 0